import { StrictMode, type FC } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'

import { ApiGatewayProvider } from '@dhl/api-gateway-provider'
import { SnackbarProvider } from '@dhl/snackbar'
import { VersionProvider } from '@dhl/version-provider'
import { I18nProvider } from '@dhl/i18n'
import { CacheProvider, ThemeProvider } from '@dhl/theme'
import { config } from '~/config'
import { AppRoutes } from './AppRoutes'
import { queryClient } from './query-client'

const { apiGatewayHost, basePath, cspNonce, version } = config

const basePathWithoutSlash = basePath.slice(0, -1)

export const App: FC = () => (
  <StrictMode>
    <ApiGatewayProvider host={apiGatewayHost}>
      <CacheProvider nonce={cspNonce}>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <I18nProvider>
              <SnackbarProvider>
                <BrowserRouter basename={basePathWithoutSlash}>
                  <VersionProvider url={`${basePath}version.json`} version={version}>
                    <AppRoutes />
                  </VersionProvider>
                </BrowserRouter>
              </SnackbarProvider>
            </I18nProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </CacheProvider>
    </ApiGatewayProvider>
  </StrictMode>
)
